import React, { FC, ReactNode } from "react";

import { useBoolean } from "~/hooks";

import { GridCell, Icon } from "~/ui";

type PropsType = {
  lists: (string | ReactNode)[];
  className?: string;
  openedMenu?: ReactNode;
};

export const GridRow: FC<PropsType> = ({
  lists,
  className = "",
  openedMenu,
}: PropsType) => {
  const { isChecked: open, toggle } = useBoolean(false);
  return (
    <div
      className="grid cursor-pointer hover:bg-primary-50 transition-colors duration-200"
      style={{
        gridTemplateColumns: `repeat(${lists.length}, 1fr)`,
        gridColumn: `span ${lists.length} / span ${lists.length}`,
      }}
    >
      {lists.map((list, index) => (
        <GridCell
          key={`gird-cell-${index}`}
          onClick={toggle}
          className={`border-b border-solid px-3 py-2 ${open ? "" : "truncate"} cursor-pointer ${className}`}
        >
          <div className="flex items-center gap-2">
            {index === 0 && (
              <div className="shrink-0">
                {open ? (
                  <Icon
                    icon="ioChevronDown"
                    className="w-4 h-4 text-secondary-600"
                  />
                ) : (
                  <Icon
                    icon="ioChevronForwardOutline"
                    className="w-4 h-4 text-secondary-600"
                  />
                )}
              </div>
            )}
            <span
              className={`${open ? "break-words" : "overflow-hidden whitespace-nowrap truncate"}`}
            >
              {list}
            </span>
          </div>
        </GridCell>
      ))}
      {open && openedMenu}
    </div>
  );
};
